import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

/**
 * Placeholder rows for {@link AysMenuComponent} until its first emission.
 *
 * The menu can only be built once MSAL is initialised and the feature
 * permissions have been fetched live, and the server-rendered HTML never gets
 * that far — so without a placeholder the sidebar shows its frame and footer
 * with nothing in between, which users read as "the menu is gone" (ZD #4539).
 *
 * The rows mirror the real menu: the pinned Home and Klia rows, one group
 * header, then its entries — same `px-4 py-2` rhythm, so nothing jumps when the
 * real entries replace them.
 */
@Component({
  selector: 'bd-menu-loading',
  template: `
    <div aria-busy="true" aria-label="Menü wird geladen" role="status">
      @for (row of rows; track $index) {
        <div class="flex items-center px-4 py-2">
          <p-skeleton
            class="ml-2"
            [width]="row.width"
            height="1.25rem"
            borderRadius="4px"
          />
        </div>
      }
    </div>
  `,
  imports: [SkeletonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BdMenuLoadingComponent {
  protected readonly rows = [
    { width: '5rem' },
    { width: '4rem' },
    { width: '6rem' },
    { width: '10rem' },
    { width: '8rem' },
    { width: '11rem' },
  ];
}
